<div class="assistant-wrapper">
  <div class="greeting-wrapper">
    <div class="indicator"
      [ngClass]="{'online': online, 'offline': !online, 'indicator-height-user-info':!isShadowingUser && !isScheduleDue && !isScheduleDueIn30Minutes,'indicator-height-schedule-un-shadow': !isShadowingUser && (isScheduleDue || isScheduleDueIn30Minutes) ,'indicator-height-schedule': isShadowingUser && (isScheduleDue || isScheduleDueIn30Minutes), 'indicator-height':isShadowingUser && !isScheduleDue && !isScheduleDueIn30Minutes }">
    </div>
    <div class="profileStack">
      <span>{{userProfile?.fullName}}</span>
      <span id="networkStatusDate"> {{currentDate | date: 'MMM d, y h:mm a'}}</span>
      @if (isShadowingUser) {
        <span class="shadow-text"> Shadowing</span>
      }
      @if (isScheduleDueIn30Minutes) {
        <span class="calendar-text">Your day is scheduled to end
        in {{finishTime}} minutes</span>
      }
      @if (isScheduleDue) {
        <span class="calendar-text">Your day was scheduled to end {{endingScheduleDate | date: 'MMM d, y h:mm a'}}</span>
      }

    </div>
    @if (online) {
      <div class="wifi-container wifi-on">
        <mat-icon>signal_wifi_4_bar</mat-icon>
        <span class="wifi-message">Online</span>
      </div>
    }
    @if (!online) {
      <div  class="wifi-container wifi-off">
        <mat-icon>signal_wifi_off</mat-icon>
        <span class="wifi-message">Offline</span>
      </div>
    }
    @if (profileStatus && profileStatus.vxFieldStatus && profileStatus.vxFieldStatus && !loading) {
      <div class="status-jobs-wrapper">
        <div class="status">{{profileStatus.vxFieldStatus.toLowerCase()}}</div>
        @if (jobsLeft) {
          <div class="jobs-left">{{jobsLeft}}</div>
        }
      </div>
    }
    @if (loading) {
      <div id="loading-holder">
        <mat-icon class="rotating" svgIcon="side-indicator"></mat-icon>
      </div>
    }

  </div>
</div>